import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggerBaseQuery, getExpApiBaseQueryWithBaseUrl } from "../common.js";
import { LIST_TAG } from "../utils.js";
import { CTM_TAGS } from "./common.js";
const ctmApi = createApi({
  reducerPath: "exp_ctm_rtkquery",
  baseQuery: getLoggerBaseQuery(getExpApiBaseQueryWithBaseUrl("https://ase.usw2-pri-1.exp.azure.net/ctmapi/", false, false)),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(CTM_TAGS)]
});
export {
  ctmApi
};
//# sourceMappingURL=api.js.map
